import { render, staticRenderFns } from "./userSettings.vue?vue&type=template&id=05e41447&"
import script from "./userSettings.vue?vue&type=script&lang=js&"
export * from "./userSettings.vue?vue&type=script&lang=js&"
import style0 from "./userSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "userSettings.vue"
export default component.exports